module.exports = __webpack_public_path__ + "static/media/marisa4.508f0248.mp3";